import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as MessageActions from './message.actions';
import { MessageEntity } from './message.models';

export const MESSAGE_FEATURE_KEY = 'message';

export interface State extends EntityState<MessageEntity> {
  selectedId?: string | number; // which Message record has been selected
  loading: boolean; // if Message list is loading
  sending: boolean; // sending message
  error?: string | null; // last none error (if any)
}

function sortByCreatedAt(m1: MessageEntity, m2: MessageEntity) {
  return m1.createdAt < m2.createdAt ? -1 : 1;
}

export interface MessagePartialState {
  readonly [MESSAGE_FEATURE_KEY]: State;
}

export function selectMessageId(message: MessageEntity): string {
  //In this case this would be optional since primary key is id
  return message._id;
}

export const messageAdapter: EntityAdapter<MessageEntity> = createEntityAdapter<MessageEntity>(
  {
    selectId: selectMessageId,
    sortComparer: sortByCreatedAt
  }
);

export const initialState: State = messageAdapter.getInitialState({
  // set initial required properties
  loading: false,
  sending: false
});

const messageReducer = createReducer(
  initialState,
  on(MessageActions.loadMessages, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(MessageActions.loadMessagesSuccess, (state, { messages }) =>
    messageAdapter.setAll(messages, { ...state, loading: false })
  ),
  on(MessageActions.loadMessagesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),

  on(MessageActions.sendMessage, state => ({
    ...state,
    sending: true,
    error: null
  })),
  on(MessageActions.sendMessageSuccess, (state, { message }) =>
    messageAdapter.setAll(
      [message, ...Object.keys(state.entities).map(key => state.entities[key])],
      { ...state, sending: false }
    )
  ),
  on(MessageActions.sendMessageFailure, (state, { error }) => ({
    ...state,
    sending: false,
    error
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return messageReducer(state, action);
}
